export default __webpack_public_path__ + "static/media/A_sound.da09b731.mp3";